const exp = (list, t, listQuery, extension) => {
  const sheetName = "Export";
  const fileNameSuffix = " " + new Date().toLocaleString() + `.${extension}`;
  const cleanList = list.map(({ __typename, ...rest }) => rest);

  switch (listQuery.name) {
    default: {
      return { formattedList: cleanList, fileName: "Export" + fileNameSuffix, sheetName: sheetName };
    }
  }
};

export default exp;
